const ListingSource = ({
  contactEmail = '',
  contactPhone = '',
  dateActivatedTimestamp = -1,
  feedName = '',
  listingAlias = '',
  isManual = false,
  photoUrl = '',
  lowPrice = 0,
  highPrice = 0,
  photoCount = 0,
  unitCount = 0,
  syndicationOverviewStatus = '',
} = {}) => ({
  contactEmail: String(contactEmail),
  contactPhone: String(contactPhone),
  dateActivatedTimestamp: Number(dateActivatedTimestamp),
  feedName: String(feedName),
  listingAlias: String(listingAlias),
  isManual: Boolean(isManual),
  photoUrl: String(photoUrl),
  lowPrice: Number(lowPrice),
  highPrice: Number(highPrice),
  photoCount: Number(photoCount),
  unitCount: Number(unitCount),
  syndicationOverviewStatus: String(syndicationOverviewStatus),
});

const ListingSourceResponse = ({
  hasManualSource = false,
  isMultifamily = false,
  address = {},
  listings = [],
}: {
  hasManualSource?: boolean;
  isMultifamily?: boolean;
  address?: { street?: string };
  listings?: Array<ReturnType<typeof ListingSource>>;
} = {}) => ({
  hasManualSource: Boolean(hasManualSource),
  isMultifamily: Boolean(isMultifamily),
  street: String(address.street || ''),
  sources: listings.map(ListingSource),
});

export default ListingSourceResponse;

export type ListingSourceResponseProps = ReturnType<typeof ListingSourceResponse>;
